export const setInviteData = '[User] set invite data';
